export default __webpack_public_path__ + "static/media/icon-simulation.643e2be0.png";